// extracted by mini-css-extract-plugin
module.exports = {"tot":"Cart_tot__15XQ0","checkoutBtn":"Cart_checkoutBtn__ZvNh_"};